<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBluetooth_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M11.888 5.002q.03-.03.059-.065a.7.7 0 0 0-.11-.984L8.342 1.157A.7.7 0 0 0 7.2 1.7v4.61L4.195 3.305a.7.7 0 0 0-.99.99L6.91 8l-3.705 3.705a.7.7 0 0 0 .99.99L7.2 9.69v4.604a.701.701 0 0 0 1.142.55l3.487-2.791.038-.032a.7.7 0 0 0 .02-1.023l-2-2L8.89 8zM8.6 9.69v3.154l1.752-1.402-1.131-1.131zm0-6.534V6.31l1.752-1.752z"
        clip-rule="evenodd"
    />
</svg>
